module.exports = __webpack_public_path__ + "img/arrow.0c734176.png";